import { useEffect, useState } from 'react'
import projectsStore from '../../screens/Projects/Store'

export const useSearchInput = () => {
  const [searchText, setSearchText] = useState<string>('')
  const { onSearchListing } = projectsStore
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      onSearchListing(searchText)
    }, 900)

    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText])

  return {
    searchText,
    setSearchText,
  }
}
